if (!customElements.get('product-colors')) {
  customElements.define('product-colors', class ProductColors extends HTMLElement {
    constructor() {
      super();
      this.loaded = false;
      this.productVariants = [];
      this.colorsWrapper = this.querySelector('.card__product-colors');
      this.mql = window.matchMedia('(min-width: 1025px)');
      if (this.querySelector('.card-wrapper')) {
        if (this.mql.matches) {
          this.querySelector('.card-wrapper').addEventListener('mouseenter', this.showProductVariants.bind(this));
        } /* else {
          this.showColorsOnScroll();
        } */
      }
      window.addEventListener('DOMContentLoaded', this.showProductVariants.bind(this), false);
    }

    showColorsOnScroll() {
      const self = this;
      const handler = (entries) => {
        if (entries[0].isIntersecting) {
          self.showProductVariants();
        }
      }

      const observer = new window.IntersectionObserver(handler);
      observer.observe(self.querySelector('.card-wrapper'));
    }

    showProductVariants() {
      const self = this;
      if (self.hasAttribute('data-variants')) {
        const productVariants = self.getAttribute('data-variants');
        const variants = productVariants.split(',');
        if (!this.loaded) {
          variants.forEach(element => self.getProductColors(element));
        }
        this.loaded = true;
      }
    }

    getProductColors(element) {
      if(element != ""){
        const self = this;
        const url  = location.origin + '/products/' + element + '?view=ajax-variants';
        fetch(url,{
            cache: "no-cache",
            //headers:{"Content-type":"application/json"}
        })
        .then(function(response) {
          if (response.ok === true) {
            return response.json();
          }
          else{
            return null;
          }
        })
        .then(function (data) {
          if(data != null){
            if (data && data.product && data.product.length > 0) {
              const color = data.product[0].color != '' ? data.product[0].color.toLowerCase().replace(' ', '-') : 'default';
              const title = data.product[0].color != '' ? data.product[0].color.toLowerCase().replace(' ', '-') : data.product[0].name;
              const label = '<a title="' + title + '" href="' + data.product[0].url + '">' +
                '<span class="color-label bgcolor-' + color + ' color--' + color + '"></span></a>';
              const labelWrapper = document.createElement('div');
              labelWrapper.innerHTML = label;
              self.colorsWrapper.appendChild(labelWrapper);
            }
          }
          else{
            throw new Error("Product data not found.");
          }
        })
        .catch(error => console.log('Unable to get [' + element + '] product.'));
      }
    }
  });
}
